<script lang="ts">
  import Image from './Image.svelte'

  export let label: string
  export let href: string
  export let src: string
  export let alt: string
</script>

<a {href} class="inline-flex flex-row items-center gap-2">
  <Image {src} {alt} width="15" height="15" />
  <span class="font-bold hover:underline">{label}</span>
</a>
